/** @format */

import { LoadingOutlined} from '@ant-design/icons';
import {  Col, Divider, Modal, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { setGlobal, useGlobal } from 'reactn';
import Steper from '../../components/CheckoutTimeLine';
import { formatPrice } from '../../components/Commons/Hooks/Functions/FormatPrice';
import { PixelFacebook } from '../../components/Commons/Hooks/Functions/PixelFacebook';
import { ENV_ISO_CURRENCY } from '../../components/Commons/Hooks/Variables/Enviroment';
import Images from '../../components/Commons/Images';
import Loading from '../../components/Commons/Loading';
import MetaDescription from '../../components/Commons/MetaDescription';
import Spacer from '../../components/Commons/Spacer';
import Countdown from '../../components/Countdown';
import TitleBox from '../../components/TitleBox';
import CardOnDemand from '../../pages/checkout/components/CardOnDemand';
import PaymentDetail from '../../pages/checkout/components/PaymentDetail';
import PaymentDetailService from '../../pages/checkout/components/PaymentDetailService';
import StepperService from '../../pages/checkout/components/StepperService';
import CustomButton from '../../v2-components/Antd/Button';
import PaymentCard from './components/PaymentCard';
import { Service } from './services';
import { CustomNotification } from '../../v2-components/Antd/Notification';
import './style.scss';
import DescriptionPrices from '../../pages/checkout/components/PaymentDetail/components/DescriptionPrices';
import { GlobalConsumer } from '../../components/Commons/Context/Global';
import BankTransferDetails from './components/PaymentCard/BankTransferDetail';
import { Service2 } from './service';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';


export default function PaymentV2() {
	const { t } = useTranslation('global');
	const [isVoucherCode] = useState(localStorage.getItem('voucherCode'));
	const [isDiscountApplied, setDiscountApplied] = useGlobal('discountPaymentApplied');
	const [isDiscountName, setDiscountName] = useGlobal('discountPaymentName');
	const [isUserAddress] = useState(JSON.parse(localStorage.getItem('locationStore')));
	const [isDataPayment] = useState(JSON.parse(localStorage.getItem('paymentData')));
	const [isCurrentOrder, setCurrentOrder] = useGlobal('orderCheckoutPayment');
	const [isPaymentMethods, setPaymentMethods] = useState(null);
	const [isPaymentName, setPaymentName] = useState(null);
	const [isButtonPaymentStatus, setButtonPaymentStatus] = useState(true);
	const [isVisible, setVisible] = useState(false);
	const [isMobile, setMobile] = useState(false);
	const [isPaymentExcedent] = useGlobal('paymentExcedent');
	const [isService, setService] = useState(false);
	const [transferFile, setTransferFile] = useState(null);
	const [isValidation, setIsValidation] = useState(false);
	const history = useHistory();
	// const [trackingId, setTrackingId] = useState(null);

	// const [showConfirmation, setShowConfirmation] = useState(false);

	const { isTransactionSelected } = GlobalConsumer();
	// eslint-disable-next-line
	const [isFromPayment, setFromPayment] = useGlobal('isFromPayment');
	// eslint-disable-next-line
	const [isFromPaymentToPDATA, setFromPaymentToDATA] = useGlobal('isFromPaymentToPDATA');


	console.log('isTransactionSelected', isTransactionSelected);
	console.log('ispayment', isPaymentName);

	const handleDeleteCart = () => {
		localStorage.setItem('cart', JSON.stringify([]));
		setGlobal(() => ({
			carQuantity: 0,
		}));
		localStorage.removeItem('retirementData');
	};

	useEffect(() => {
		if (isDataPayment) {
			if (window.innerWidth < 992) {
				setMobile(true);
			}
			new Service()
				.checkOrder(isDataPayment)
				.then((response) => {
					if (response.valid_recipe === false) {
						CustomNotification({
							type: 'error',
							message: 'Error en Receta!',
							description: '¡Lo sentimos algo paso con su Receta, por favor vuelva a subirla!.',
							duration: 5,
						});
						return (window.location.href = '/checkout/prescription');
					}
					if (response) {
						if (response.order?.services?.length > 0) {
							setService(response.order?.services[0]);
						}
						setCurrentOrder(response.order);
						PixelFacebook('AddPaymentInfo', {
							currency: ENV_ISO_CURRENCY,
							value: parseInt(response.total).toFixed(2),
						});
					}
				})
				.catch((error) => {
					console.log('error', error);
					CustomNotification({ type: 'error', message: 'Error', description: 'Faltan datos para completar la transacción' });
					return (window.location.href = '/cart');
				});
		} else {
			window.location.href = '/';
		}
	}, [isDataPayment, isVoucherCode, setCurrentOrder]);

	useEffect(() => {
		new Service()
			.paymentList()
			.then((response) => {
				setPaymentMethods(response);
			})
			.catch((error) => {
				console.log('error', error);
				CustomNotification({ type: 'error', message: 'Error', description: 'Hubo un error obteniendo los medios de pago' });
			});
	}, []);

	const handleSelectPayment = (item) => {
		setButtonPaymentStatus(true);
		setPaymentName(item);
		if (!isPaymentExcedent) {
			new Service()
				.checkPaymentDisscount(isDataPayment, item)
				.then((response) => {
					if (response) {
						if (response.payment_method_rules && response.payment_method_rules.discount !== 0) {
							setDiscountApplied(true);
							setDiscountName(response.payment_method_name);
						} else {
							setDiscountApplied(false);
							setDiscountName(null);
						}
						setCurrentOrder(response);
					}
				})
				.catch((error) => {
					console.log('error', error);
					CustomNotification({ type: 'error', message: 'Error', description: 'Ocurrió un error al calcular los descuentos' });
				});
		}
		setButtonPaymentStatus(false);
	};

	useEffect(() => {
		setFromPayment(true);
	}, [setFromPayment]);

	useEffect(() => {
		setFromPaymentToDATA(true);
	}, [setFromPaymentToDATA]);

	const handlePayment = async (item, data) => {
		if (isTransactionSelected && !transferFile) {
			CustomNotification({
				type: 'error',
				message: 'Error',
				description: 'Falta adjuntar el comprobante de pago para avanzar',
				duration: 5,
			});

			setIsValidation(true);
			return; // Detiene la función y no deja avanzar
		}
		// ------------------------------
		if (!isVisible) {
			setVisible(true);
		}
		if (!isButtonPaymentStatus) {
			setButtonPaymentStatus(true);
		}

		let paymentMethodName = isPaymentName;
		let orderTotal = isCurrentOrder.total;

		if (item) {
			if (item.cover_payment) {
				paymentMethodName = data;
			}
			orderTotal = parseFloat(orderTotal) - parseFloat(item.amountAuthorized);
		}

		try {
			const response = await new Service().payment(parseFloat(orderTotal), isDataPayment, paymentMethodName);

			// Lógica específica para transferencia bancaria (subida PUT)
			if (isTransactionSelected && response?.external_data?.url) {
				const uploadUrl = response.external_data.url;

				try {
					// Realizamos el PUT directamente al endpoint devuelto
					const uploadResponse = await fetch(uploadUrl, {
						method: 'PUT',
						body: transferFile,
					});
					console.log('PUT status:', uploadResponse.status);
					console.log('PUT headers:', [...uploadResponse.headers.entries()]);
					const text = await uploadResponse.text().catch(() => '');
					console.log('PUT body:', text);

					if (uploadResponse.ok) {
						setGlobal(() => ({
							paymentExcedent: null,
							paymentRequestExcedent: null,
						}));

						setVisible(false);

						CustomNotification({
							type: 'success',
							message: '¡Éxito!',
							description: 'Comprobante subido y pedido procesado correctamente.',
							duration: 5,
						});

						const paymentDataLS = JSON.parse(localStorage.getItem('paymentData'));

						const trackingResponse = await new Service2().trackOrder(paymentDataLS);

						console.log('tracking en payment', trackingResponse);

						const rawTrackingId = trackingResponse?.tracking_id || trackingResponse?.data?.tracking_id;

						if (!rawTrackingId) {
							throw new Error('trackOrder no devolvió tracking_id');
						}

						// setTrackingId(`${rawTrackingId}-P`);

						// setShowConfirmation(true);
						handleDeleteCart();
						history.replace('/checkout/preorder', {
							trackingId: `${rawTrackingId}`,
						});
					} else {
						throw new Error('Error en la subida del archivo');
					}
				} catch (uploadError) {
					console.error(uploadError);
					setVisible(false);
					setButtonPaymentStatus(false);
					CustomNotification({
						type: 'error',
						message: 'Error al subir comprobante',
						description: 'Ocurrió un error al subir el archivo, por favor contacte a soporte.',
						duration: 10,
					});
				}
			} else {
				// Flujo normal para otros medios de pago
				setVisible(false);
				setPaymentName(null);
				setButtonPaymentStatus(true);
				setGlobal(() => ({
					paymentExcedent: null,
					paymentRequestExcedent: null,
				}));
				window.location.href = response.external_data.url;
			}
		} catch (error) {
			setVisible(false);
			setButtonPaymentStatus(false); // Reactivar botón si falla
			CustomNotification({ type: 'error', message: 'Error!', description: 'Ocurrió un Error, por favor vuelva a intentarlo', duration: 10 });
		}
	};

	const handlePaytmentExedent = () => {
		return formatPrice(isCurrentOrder.total);
	};

	if (!isCurrentOrder || !isPaymentMethods) {
		return <Loading />;
	}

	console.log('isTransactionF');
	// PANTALLA DE CONFIRMACIÓN (ShowConfirmation)

	// if (showConfirmation) {
	// 	return (
	// 		<div className="quote-request-container" style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
	// 			<div className="header-section">
	// 				<h2 style={{ marginBottom: '0' }}>Confirmación de Pedido</h2>
	// 			</div>
	// 			<div className="confirmation-wrapper" style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
	// 				<div
	// 					className="confirmation-card"
	// 					style={{ textAlign: 'center', background: '#fff', padding: '40px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
	// 				>
	// 					<div className="confirmation-content">
	// 						<div>
	// 							{/* Usamos checkIcon si existe, si no, un icono de Antd como fallback */}
	// 							{checkIcon ? (
	// 								<img src={checkIcon} alt="Check" width={180} height={180} />
	// 							) : (
	// 								<CheckCircleOutlined style={{ fontSize: '150px', color: '#52c41a' }} />
	// 							)}
	// 						</div>
	// 						<div className="confirmation-text" style={{ marginTop: '20px' }}>
	// 							<p className="confirmation-title" style={{ fontSize: '24px', fontWeight: 'bold', color: '#333' }}>
	// 								¡Gracias por tu compra!
	// 							</p>
	// 							<p className="contact-info" style={{ fontSize: '16px', color: '#666', margin: '15px 0' }}>
	// 								Hemos recibido tu comprobante de transferencia correctamente.
	// 								<br />
	// 								Te enviaremos un correo con los detalles de tu pedido.
	// 							</p>
	// 							<Button type="primary" size="large" onClick={handleBackToStore} className="volver-btn" style={{ marginTop: '20px', padding: '0 40px' }}>
	// 								Seguir navegando
	// 							</Button>
	// 							<div style={{ marginTop: '30px' }}>
	// 								<Text className="contact-info" type="secondary">
	// 									Ante cualquier duda, escríbenos a{' '}
	// 									<a href="mailto:contacto@benestarx.com" className="contact-email">
	// 										contacto@narma.cl
	// 										<p style={{ fontSize: '16px', color: '#333', marginTop: '10px' }}>
	// 											<b>N° de seguimiento:</b> {trackingId || '-'}
	// 										</p>
	// 									</a>
	// 								</Text>
	// 							</div>
	// 						</div>
	// 					</div>
	// 				</div>
	// 			</div>
	// 		</div>
	// 	);
	// }

	// PANTALLA NORMAL DE PAGO
	return (
		<>
			<MetaDescription title={t('main.metaTitle')} name={'description'} content={t('main.metaContent')} />
			<div className="ph-payment-global-container">
				<div className="ph-payment-main-container">
					{isService ? <StepperService step={1} /> : <Steper step={2} />}

					<div className="ph-payment-titlebox-countdown-container">
						<TitleBox image={'pharol-lock'} title={'Pago'} checkout={true} />
						<Countdown service={isService} />
					</div>
					<Row>
						{isPaymentMethods && (
							<Col xs={24} sm={24} md={24} lg={17} xl={17}>
								<div className="ph-payment-gateways-container">
									<>
										{isPaymentMethods.length > 0 && (
											<>
												<div className="ph-payment-method-title-container">
													{/* <CreditCardOutlined className="ph-payment-method-icon" /> */}
													<h4 className="ph-payment-method-title">Elegir medio de pago</h4>
												</div>
												<Divider style={{ marginBottom: '14px', marginTop: '1px' }}></Divider>
												<Row gutter={[16, 16]}>
													{isPaymentMethods.map((item, index) => (
														<Col xs={24} sm={24} md={12} key={index}>
															<PaymentCard
																isPaymentExcedent={isPaymentExcedent}
																isDiscountName={isDiscountName}
																active={item.active}
																available={item.active}
																selectPayment={(item) => handleSelectPayment(item)}
																paymentMethod={item.payment_option_id}
																paymentSelected={isPaymentName}
																name={item.display_name}
																image={item.image}
																type={item.type}
															/>
														</Col>
													))}
												</Row>
											</>
										)}
									</>
								</div>

								{isTransactionSelected && (
									<div>
										<BankTransferDetails onFileUpload={setTransferFile} isValidation={isValidation} setIsValidation={setIsValidation} />
									</div>
								)}
							</Col>
						)}
						<Col xs={24} sm={24} md={24} lg={7} xl={7} className="ph-payment-box-global-container">
							{isDiscountApplied && (
								<div className="ph-payment-box-discount-main-container">
									<Images
										classContent={'ph-payment-box-discount-image-container'}
										classImage={'ph-payment-box-discount-image'}
										default={`https://storage.googleapis.com/master-image-bucket/home/Tipos%20de%20entrega.png`}
										title={'Discount'}
									/>
									<div className="ph-payment-box-discount-container">
										<h4 className="ph-payment-box-discount-title">¡Descuento en Despacho!</h4>
										<h4 className="ph-payment-box-discount-description">
											<span className="ph-payment-box-discount-subtitle">Descuento Adicional</span> en método de pago seleccionado...
										</h4>
									</div>
								</div>
							)}
							{isCurrentOrder.type_calculation !== 'service' && <CardOnDemand />}
							<div className="ph-payment-box-main-container">
								{isService ? (
									<PaymentDetailService item={isCurrentOrder} />
								) : (
									<PaymentDetail
										isDiscountApplied={isDiscountApplied}
										address={isUserAddress}
										paymentRetirement={isCurrentOrder.info.type_retirement}
										item={isCurrentOrder}
									/>
								)}
								<div className="ph-checkout-payment-button-main-container">
					{isMobile && (
						<>
							<div>
								<h3 className="ph-checkout-detail-button-mobile-price-main-title">Total a pagar:</h3>
								<h3 className="ph-checkout-detail-button-mobile-price-title">
									<span className="ph-checkout-detail-button-mobile-price-description"></span>
									{handlePaytmentExedent()}
								</h3>
							</div>
							<Spacer />
						</>
					)}
									<div className="ph-checkout-main-box-delivery-container"></div>
									{!isMobile && <DescriptionPrices type="retirement" title={`Total a pagar:`} price={isCurrentOrder.total} />}
									<CustomButton className={'button-primary'} style={{ marginTop: '15px' }} onClick={() => handlePayment()} disabled={isButtonPaymentStatus}>
										Finalizar Compra
									</CustomButton>
								</div>
							</div>
						</Col>
					</Row>
				</div>
			</div>
			<Modal
				wrapClassName="ph-checkout-pay-payment-modal"
				centered
				title="Proceso de pago"
				visible={isVisible}
				cancelButtonProps={{ style: { display: 'none' } }}
				okButtonProps={{ style: { display: 'none' } }}
				okText=""
				cancelText=""
				width={350}
				header={false}
				footer={false}
			>
				<h4 className="ph-checkout-pay-payment-modal-title">Estas a punto de finalizar tu compra...</h4>
				<Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
			</Modal>
		</>
	);
}
